import { frac } from "./frac";
import { Fraction } from "./types";

interface CmToFeetAndInches {
  feet: number;
  inches: Fraction;
  nextInch: number;
}

export const cmToFeetAndInches = (cmNum: number): CmToFeetAndInches => {
  const inchesFloat = cmNum * 0.3937;
  const feet = Math.floor(inchesFloat / 12);
  const inchesRemainingFloat = inchesFloat % 12;
  const inches = frac(inchesRemainingFloat);
  const nextInch = Math.ceil(inchesFloat);
  return {
    feet,
    inches,
    nextInch,
  };
};
